const InfoBubbleMode = {
    HOVER: 'HOVER',
    CLICK: 'CLICK',
};

export default InfoBubbleMode;
